<template>
  <Form ref="companyInfo" :model="addParams" :rules="addRules" :label-width="160" class="add-company">
    <template>
      <FormItem label="企业名称" prop="companyName">
        <reSelect placeholder="请输入企业名称" v-model="addParams.companyName" :loadingText="loadingText"
                  @on-open-change="onOpenChange" @on-change="onChange" @select-search='inputSearch' @dropdownScroll="dropdownScroll">
          <Option v-for="item in companyNameOptions" :key="item.id" :value="item.name" :label="item.name"></Option>
          <Option value="" label="加载中..." disabled v-if="companyNameOptions.length && loadingFlag"></Option>
        </reSelect>
      </FormItem>
      <FormItem label="企业类型" prop="companyType">
        <Input v-model="addParams.companyType" disabled></Input>
      </FormItem>
      <FormItem label="企业域" prop="companyDomain">
        <div>
          <Input v-model="addParams.companyDomain" placeholder="请输入企业域"/>
          <div class="tip-bottom">小于等于50位字符，可由英文大小写组成</div>
        </div>
      </FormItem>
      <FormItem label="管理员账号" prop="sellerName">
        <div>
          <Input v-model="addParams.sellerName" placeholder="请输入管理员账号" />
          <span class="tip-bottom">3-15位字符，可由中文和英文组成，建议使用admin</span>
        </div>
      </FormItem>
      <FormItem label="密码" prop="password">
        <div>
          <Input type="password" t v-model="addParams.password" placeholder="请输入密码" />
          <span class="tip-bottom">6-20位字符，可由英文、数字及标点符号组成</span>
        </div>
      </FormItem>
      <FormItem  label="确认密码" prop="repeatPassword">
        <Input type="password" v-model="addParams.repeatPassword" placeholder="请确认密码" />
      </FormItem>
      <FormItem class="user-company-type" label="类型" prop="type">
        <RadioGroup v-model="addParams.type">
          <Radio :label="1">试用</Radio>
          <Radio :label="2">正式</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem  class='is-test' label="是否测试账号" prop="is_test">
        <RadioGroup v-model="addParams.is_test">
          <Radio label="0">否</Radio>
          <Radio label="1">是</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem  class='hy-level' label="会员类型" prop="hyLevel">
        <RadioGroup v-model="addParams.hyLevel" @on-change='levelChange'>
          <Radio label="0">普通会员</Radio>
          <Radio label="1">初级会员</Radio>
          <Radio label="2">中级会员</Radio>
          <Radio label="3">高级会员</Radio>
          <Radio label="4">SVIP会员</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem class="data-item ivu-form-item-required" label="有效期" prop="checkDate" v-if='addParams.hyLevel !== "0"'>
        <div class="data-col">
          <FormItem prop="startDate">
            <DatePicker v-model="addParams.startDate" type="date" placeholder="开始日期" style="width: 220px"></DatePicker>
          </FormItem>
        </div>
        <span class="line"></span>
        <div class="data-col">
          <FormItem prop="startDate">
            <DatePicker v-model="addParams.endDate" type="date" placeholder="结束日期" style="width: 220px"></DatePicker>
          </FormItem>
        </div>
      </FormItem>
      <FormItem label="最大开通子账号数量" prop="maxAccount" class='unit limit-group'>
        <RadioGroup v-model='addParams.maxAccount'>
          <Radio label='limit'>
            <Input type="text" v-model="realMaxAccount" placeholder="请填写开通子账号数量" :disabled='addParams.maxAccount === "noLimit"' /><span class='text'>个</span>
          </Radio>
          <Radio label='noLimit'><span class='text'>不限</span></Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="容量空间" prop="volume" class='unit'>
        <div>
          <Input type="text" v-model="addParams.volume" placeholder="请填写空间容量" /><span class='danwei'>G</span>
        </div>
      </FormItem>
      <FormItem label="开启/禁用" prop="companyState">
        <i-switch v-model="addParams.companyState" size="small"/>
      </FormItem>
    </template>
    <button  type="primary" @click.prevent="handleSubmit()" class="ivu-btn ivu-btn-primary" :disabled="disabledFlag">确认提交</button>
  </Form>
</template>

<script>
import { dateObjToStr2 } from '@/utils/common'
import { getSelectOption, addIndustry, checkCompany, checkCompanyDomain, memberAccountDefault } from '@/api/userManager'
import { msg } from '@/utils/index.js'
import reSelect from '@/components/reSelect/select.vue'
import _ from 'underscore'
import addComMixin from './components/addComMixin'
export default {
  name: 'detailInfo',
  components: { reSelect },
  mixins: [addComMixin],
  data() {
    const validateComName = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        callback(new Error('请输入企业名称'))
      }
      checkCompany({
        company_name: value
      }).then(res => {
        const { code, result } = res
        if (code === 0) {
          if (result === 'true') {
            callback()
          } else {
            callback(new Error('企业名称已存在'))
          }
        } else {
          callback(new Error('检测公司失败'))
        }
      })
    }
    const validateComDomain = (rule, value, callback) => {
      const reg = /^[A-Za-z]{1,}$/
      if (value === '') {
        callback(new Error('请输入企业域'))
      } else if (value.length > 50) {
        callback(new Error('企业域最长为50位'))
      } else if (!(reg).test(value)) {
        callback(new Error('请输入英文'))
      } else {
        checkCompanyDomain({ company_domain: value }).then(res => {
          const { code, result } = res
          if (code === 0 && result === 'true') {
            callback()
          } else {
            callback(new Error('企业域已存在'))
          }
        })
      }
    }
    const validatePassword = (rule, value, callback) => {
      const reg = /[\u4e00-\u9fa5]/
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (value.length < 6) {
        callback(new Error('密码最短为6位'))
      } else if (value.length > 20) {
        callback(new Error('密码最长为20位'))
      } else if (reg.test(value)) {
        callback(new Error('请不要使用汉字'))
      } else {
        callback()
      }
    }
    const validateRePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入确认密码'))
      } else if (value !== this.addParams.password) {
        callback(new Error('密码输入不一致'))
      } else {
        callback()
      }
    }
    const validateAdmin = (rule, value, callback) => {
      const reg = /^[\u4e00-\u9fa5a-zA-Z0-9]{3,15}$/
      if (value.length < 3) {
        callback(new Error('管理员账号最短为3位'))
      } else if (value.length > 15) {
        callback(new Error('管理员账号最长为15位'))
      } else if (!reg.test(value)) {
        callback(new Error('请使用中文和字母组合'))
      } else {
        callback()
      }
    }
    const validateStartDate = (rule, value, callback) => {
      this.$refs['companyInfo'].validateField('checkDate')
      callback()
    }
    const validateCheckDate = (rule, value, callback) => {
      if (!this.addParams.startDate) {
        callback(new Error('开始时间不能为空'))
      } else if (!this.addParams.endDate) {
        callback(new Error('结束时间不能为空'))
      } else if (this.addParams.startDate.getTime() === this.addParams.endDate.getTime()) {
        callback(new Error('时间不能有重合'))
      } else if (this.addParams.startDate > this.addParams.endDate) {
        callback(new Error('结束时间不能早于开始时间'))
      } else {
        callback()
      }
    }
    const validateCheckAccount = (rule, value, callback) => {
      const reg = /^([1-9]\d*|[0]{1,1})$/
      if (!value) {
        callback(new Error('请输入子账号数量'))
      }
      if (value === 'limit') {
        if (!reg.test(this.realMaxAccount)) {
          callback(new Error('请输入正确的子账号数量'))
        }
      }
      callback()
    }
    const validateCheckVolume = (rule, value, callback) => {
      const reg = /^([0-9]+.?[0-9]*|(0|\+?[1-9][0-9]*)|[1-9]\d*)$/
      if (!value) {
        callback(new Error('请输入子容量空间'))
      }
      if (!reg.test(value)) {
        callback(new Error('请输入正确的数字'))
      }
      callback()
    }
    return {
      industryOrService: '', // 工业还是服务
      columeObj: {}, // 用来缓存容量的
      addParams: {
        infoId: '', // 数据的id 从下拉选项中获取的
        companyName: '', // 企业名称
        companyType: '', // 企业类型
        companyDomain: '', // 企业域
        sellerName: '', // 管理员账号
        password: '',
        repeatPassword: '',
        type: 1, // 1 适用 2 正式
        startDate: '',
        endDate: '',
        companyState: true, // 0 关闭 1 开始
        hyLevel: '', // 会员等级
        is_test: '', // 1是 0否 是否测试账号
        maxAccount: '', // limit限制  noLimit 不限制
        volume: '' // 空间容量 M 1000换算
      },
      realMaxAccount: '',
      addRules: {
        companyName: [
          { required: true, validator: validateComName, trigger: 'change' }
        ],
        companyType: [
          { required: true, message: '请输入企业类型', trigger: 'blur' }
        ],
        companyDomain: [
          { required: true, validator: validateComDomain, trigger: 'blur' }
        ],
        sellerName: [
          { required: true, message: '请输入管理员账号', trigger: 'blur' },
          { validator: validateAdmin, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
        repeatPassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: validateRePassword, trigger: 'blur' }
        ],
        startDate: [
          { validator: validateStartDate, trigger: 'change' }
        ],
        checkDate: [
          { validator: validateCheckDate }
        ],
        type: [
          { required: true, message: '', trigger: 'change', type: 'number' }
        ],
        hyLevel: [
          { required: true, message: '请选择会员类型', trigger: 'change' }
        ],
        is_test: [
          { required: true, message: '请选择是否测试账号', trigger: 'change' }
        ],
        companyState: [
          { required: true, message: ' ', trigger: 'change', type: 'boolean' }
        ],
        maxAccount: [
          { required: true, validator: validateCheckAccount, trigger: 'change' }
        ],
        volume: [
          { required: true, validator: validateCheckVolume, trigger: 'blur' }
        ]
      },
      companyNameOptions: [], // 06-20 选项的集合
      searchValue: '',
      currentPage: 1, // 下拉搜索当前页数
      disabledFlag: false, // 提交的点击状态
      loadingFlag: true, // select 选项区是否展示滚动加载中的提示
      loadingText: '暂无搜索内容', // select选项去的默认字段
      number: 0 // 试一试能不能解决下拉获取option 和 input改变的获取option的bug
    }
  },
  computed: {
    disabled() {
      return this.editParams.isLock === true // 按时实现不能锁
    }
  },
  watch: {
    'addParams.companyName': {
      handler(value) {
        if (!value) {
          this.addParams.companyType = ''
        }
      },
      immediate: true
    }
  },
  created() {
    const pageObj = { title: '新增', type: 'small', url: '' }
    pageObj.url = this.$route.name.indexOf('Industry') !== -1 ? 'industryList' : 'serverList'
    this.$store.dispatch('setPage', pageObj)
    this.industryOrService = this.$route.name.indexOf('Industry') !== -1 ? 'i' : 's'
    this.getColumeObj()
  },
  methods: {
    inputSearch: _.debounce(function(value) {
      this.searchValue = value
      this.companyNameOptions = []
      this.currentPage = 1
      this.loadingFlag = true
      this.loadingText = '正在加载数据...'
      this.searchOrScrollGetOption()
    }, 300, false),
    handleSubmit() {
      this.$refs.companyInfo.validate((valid) => {
        if (valid) {
          const params = {
            data: {
              info_id: this.addParams.infoId,
              company_name: this.addParams.companyName,
              seller_name: this.addParams.sellerName,
              password: this.addParams.password,
              repeat_password: this.addParams.repeatPassword,
              company_type: this.addParams.companyType,
              type: this.addParams.type,
              start_date: dateObjToStr2(this.addParams.startDate),
              end_date: dateObjToStr2(this.addParams.endDate),
              company_domain: this.addParams.companyDomain,
              company_state: this.addParams.companyState ? 1 : 0,
              hy_level: this.addParams.hyLevel,
              is_test: this.addParams.is_test,
              max_account: this.addParams.maxAccount === 'limit' ? this.realMaxAccount : '9999',
              volume: this.addParams.volume * 1000
            },
            type: this.industryOrService
          }
          this.add(params)
        } else {
          return false
        }
      })
    },
    add(params) {
      this.disabledFlag = true
      addIndustry(params).then(res => {
        this.disabledFlag = false
        const { code } = res
        if (code === 0) {
          this.$router.push({ name: this.industryOrService === 'i' ? 'industryList' : 'serverList' })
        } else {
          msg.call(this, '提交失败！')
        }
      })
    },
    onOpenChange(flag) { // 下拉框的点击下拉事件
      if (flag) { // 代表执行的是打开状态
        this.searchValue = ''
        this.companyNameOptions = []
        this.addParams.companyName = ''
        this.currentPage = 1
        this.loadingFlag = true
        this.loadingText = '正在加载数据...'
        this.searchOrScrollGetOption()
      }
    },
    onChange(value) {
      this.companyNameOptions.forEach(item => {
        if (item.name === value) {
          this.addParams.companyType = item.org_type_2_text
          this.addParams.infoId = item.id
        }
      })
    },
    dropdownScroll: _.debounce(function() {
      if (!this.loadingFlag) {
        return false
      }
      this.currentPage += 1
      this.searchOrScrollGetOption()
    }, 500, true),
    searchOrScrollGetOption() { // 搜索或者下拉获取接口
      this.number += 1
      const number = this.number
      this.loadingFlag = true
      getSelectOption({
        corp_type_key: this.industryOrService === 'i' ? 1 : 2,
        current_page: this.currentPage,
        key: this.searchValue
      }).then(res => {
        if (number !== this.number) { // 不是当前请求的返回值直接拒绝
          return false
        }
        if (res.code === 0) {
          if (res.result.list.length < 20) {
            this.loadingFlag = false
          }
          if (this.currentPage === 1) {
            this.companyNameOptions = res.result.list
          } else { // 下拉加载数据
            if (res.result.list && !res.result.list.length) {
              this.$Message.info('没有更多数据了！')
              return false
            }
            this.companyNameOptions = this.companyNameOptions.concat(res.result.list)
          }
          if (this.companyNameOptions.length === 0) {
            this.loadingText = '没有查询到数据！'
          }
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
          if (this.currentPage === 1) { // 只有是搜索时才清空当前选项
            this.companyNameOptions = []
          }
        }
      })
    },
    getColumeObj() {
      memberAccountDefault({
        level: -1
      }).then(res => {
        if (res.code === 0) {
          this.columeObj = res.result
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
        }
      })
    },
    levelChange() {
      this.columeObj.forEach(item => {
        if (item.hy_level === this.addParams.hyLevel * 1) {
          this.addParams.maxAccount = item.max_account === 9999 ? 'noLimit' : 'limit'
          this.realMaxAccount = item.max_account === 9999 ? '' : item.max_account
          this.addParams.volume = item.volume / 1000
        }
      })
      if (this.addParams.hyLevel === '0') {
        this.addParams.startDate = new Date()
        this.addParams.endDate = new Date('2099-12-31 00:00:00')
      } else {
        this.addParams.startDate = ''
        this.addParams.endDate = ''
      }
    }
  }
}
</script>

<style lang="scss">
  .add-company {
    line-height: 16px;
    .ivu-form-item {
      .ivu-input {
        width: 220px;
      }
      .danwei {
        font-size: 12px;
        position: absolute;
        left: 226px;
      }
      .ivu-select {
        width: 220px;
        .ivu-select-selection { // 下拉框变红色
          border-color: #D9E2EF;
          box-shadow: none;
        }
      }
      .ivu-radio-wrapper {
        padding: 0;
      }
    }
    .hy-level,
    .is-test {
      &.ivu-form-item,
      .ivu-form-item-label,
      .ivu-form-item-content,
      .ivu-radio-wrapper {
        line-height: 16px;
        min-height: 16px;
      }
      .ivu-form-item-content {
        .ivu-form-item-error-tip {
          left: 463px;
          padding: 2px 0;
          white-space: nowrap;
        }
      }
    }
    .hy-level .ivu-form-item-content .ivu-form-item-error-tip { left: 420px; }
    .is-test .ivu-form-item-content .ivu-form-item-error-tip { left: 90px; }

    .hy-level,
    .user-company-type {
      &.ivu-form-item,
      .ivu-form-item-label,
      .ivu-form-item-content,
      .ivu-radio-wrapper {
        line-height: 16px;
        min-height: 16px;
      }
    }
    .unit {
      .ivu-form-item-content {
        .ivu-form-item-error-tip {
          left: 234px;
          white-space: nowrap;
        }
      }
    }

    .unit.limit-group {
      line-height: 32px;
      .ivu-input-wrapper {
        input {
          width: 200px;
        }
      }
      .ivu-radio-wrapper {
        line-height: 32px;
        &:nth-child(1) {
          .text {
            position: absolute;
            left: 224px;
          }
        }
        &:nth-child(2) {
          padding-left: 20px;
        }
      }
      .ivu-form-item-content {
        .ivu-form-item-error-tip {
          left: 306px;
          white-space: nowrap;
        }
      }
    }
    .data-item {
      .ivu-form-item-content {
        .ivu-form-item-error-tip {
          left: 470px;
          white-space: nowrap;
        }
      }
    }
    .ivu-select { // 封装的reSelect的样式
      width: 220px;
      .ivu-select-dropdown {
        width: 220px;
        padding-top: 0px;
        overflow: inherit;
        max-height: 250px;
        .yjh_select__search {
          position: relative;
          padding: 4px 0px;
          > input {
            width: calc( 100% - 24px);
            margin-left: 10px;
            padding: 4px 0px;
            border: none;
            border-bottom: 1px solid #1881DC;
          }
          > i {
            position: absolute;
            right: 10px;
            top: 8px;
          }
        }
        .yjh-scroll {
          margin-top: 4px;
          overflow-x: hidden;
          overflow-y: auto;
          max-height: 200px;
        }
        .ivu-select-item {
          font-size: 19px;
          color: #5D6F80;
          font-weight:400;
          // font-family:PingFangSC-Regular;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
    .seacharea {
      height: 30px;
      position: relative;
      .search_input {
        height: 25px;
        width: calc(100% - 24px);
        margin-top: 5px;
        margin-left: 10px;
        border: none;
        border-bottom: 1px solid #8796B0;
        &:focus {
          border-bottom: 1px solid #1881DC;
        }
      }
      i {
        position: absolute;
        right: 10px;
        top: 8px;
      }
    }
  }
</style>
